import { DeleteOutline } from '@mui/icons-material';
import { Box, Grid, IconButton, MenuItem, Modal, Select } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import CloseIcon from '@mui/icons-material/Close';
import { DataGrid } from '@mui/x-data-grid';
import React, { useCallback, useState, useEffect } from 'react';
import GCItemSearch from '../../../component/ReuseableComponent/GCItemSearch';
import { getGitterColumns } from '../../../Utility/Utilitys';
import {
  getStkTransItemSearch,
  getStkTransItem,
  deleteDCStockTransferItem
} from '../actions';
import { confirmAlert } from 'react-confirm-alert';
import moment from 'moment';
import { RequestPackQtySelection } from './RequestPackQtySelection';

export default function DCStockTransferItemGrid({
  xMobileScreen,
  xMediaQuery,
  xItemList,
  xSetItemList,
  rdxHeadObj,
  fAddItem,
  sItemSearchModal,
  setItemSearchModal,
  setSelectedID,
  selectedID,
  ItemPackQty,
  sItemPackQtyModal,
  setItemPackQtyModal
}) {
  // const [selectedID, setSelectedID] = useState(0);
  // const [sItemSearchModal, setItemSearchModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const handleEditCellChange = (params) => {
    if (params.field === 'PackQty') {
      setIsEditing(true);
    }
  };

  const handleEditCellChangeCommitted = (params) => {
    if (params.field === 'PackQty') {
      setIsEditing(false);
    }
  };
  const [sSelectedRow, setSelectedRow] = useState({});
  const [sPkListRow, setPkListRow] = useState([]);
  const [sCurrentRowSelected, setCurrentRowSelected] = useState(false);
  const [sGridSelectRowData, setGridSelectRowData] = useState([]);
  const [sGridSelectColData, setGridSelectColData] = useState([]);
  const [sItemSearchModalObj, setItemSearchModalObj] = useState({
    vItemNameCode: '',
    vItemNameName: '',
    vItemNameBarcode: '',
    vItemNameRefNo: ''
  });
  const [sEnterKeyObj, setEnterKeyObj] = useState({
    key: 'Enter'
  });
  const [sLoadingItemSearch, setLoadingItemSearch] = useState(false);
  const [sPackingModal, setPackingModal] = useState(false);
  const [sPackingData, setPackingData] = useState([]);

  // const setTSRQty = (params, xQty, xPackQty) => {
  //   let itemList = xItemList.map((i) => {
  //     return i.IL_ItmCd === params.row.IL_ItmCd

  //       ? {
  //           ...i,
  //           B_Tsr_Qty: xQty,
  //           B_Tsr_BaseQty: Number(xQty) * Number(i.xPackQty),
  //           packingDate: sPackingData?.length > 0 ? sPackingData : i.packingDate
  //         }
  //       : i;
  //   });
  //   xSetItemList(itemList);
  //   return { ...params.row, FinalQty: xQty };
  // };

  // fuctional changed due to PackQty-selectionModal
  const setTSRQty = (params, xQty, xPackQty) => {
    const n = (v) => (Number.isFinite(Number(v)) ? Number(v) : 0);

    const qty = n(xQty);
    const pack = n(xPackQty ?? params.row.B_Tsr_PackQty ?? params.row.xPackQty);
    const base = qty * pack;

    xSetItemList((prev) =>
      prev.map((i) =>
        i.IL_ItmCd === params.row.IL_ItmCd
          ? {
              ...i,
              B_Tsr_Qty: qty,
              B_Tsr_BaseQty: Math.round(base),
              packingDate: sPackingData?.length > 0 ? sPackingData : i.packingDate
            }
          : i
      )
    );

    // Return updated row for DataGrid valueSetter
    return { ...params.row, B_Tsr_Qty: qty, B_Tsr_BaseQty: base, FinalQty: qty };
  };

  // Inline Pack Qty edit — recompute the dependent (live) fields.
  const setTSRPackQty = (params, xPackQty) => {
    const n = (v) => (Number.isFinite(Number(v)) ? Number(v) : 0);

    const pack = n(xPackQty);
    const qty = n(params.row.B_Tsr_Qty);
    const cost = n(params.row.CostPr);
    const stock = n(params.row.IL_Stock);
    const dcPick = n(params.row.DCPick);

    const recalc = {
      B_Tsr_PackQty: pack,
      B_Tsr_BaseQty: Math.round(qty * pack),
      B_Tsr_UnitRate: cost * pack,
      IL_StockCTN: pack === 0 ? 0 : stock / pack,
      DCPickShowing: pack === 0 ? 0 : dcPick / pack
    };

    xSetItemList((prev) =>
      prev.map((i) => (i.IL_ItmCd === params.row.IL_ItmCd ? { ...i, ...recalc } : i))
    );

    return { ...params.row, ...recalc };
  };

  // Inline OverHead edit.
  const setTSROverHead = (params, xOverHead) => {
    const n = (v) => (Number.isFinite(Number(v)) ? Number(v) : 0);
    const overHead = n(xOverHead);

    xSetItemList((prev) =>
      prev.map((i) =>
        i.IL_ItmCd === params.row.IL_ItmCd ? { ...i, IL_OverHead: overHead } : i
      )
    );

    return { ...params.row, IL_OverHead: overHead };
  };

  const setPackQty_V1 = (params, PkValue, xQty, xisQtyEditAllowed) => {
    // let unitObj = params.row.units.find(u => u.Unit === params.row.B_Tsr_Unit);
    // let unitRate = Number((Number(unitObj?.CostPr) * Number(params.value)).toFixed(3));

    let itemList = xItemList.map((i) => {
      const transferRatio = Number(i.SuggestedTransfer) / Number(PkValue);
      const baseQty = Number(PkValue) * Number(i.B_Tsr_Qty);

      return i.IL_ItmCd === params.row.IL_ItmCd
        ? {
            ...i,
            B_Tsr_PackQty: PkValue,
            // B_Tsr_UnitRate: unitRate,
            B_Tsr_UnitRate: Number(Number(i?.CostPr) * Number(PkValue)),
            B_Tsr_BaseQty: Math.round(baseQty),
            // SuggestedTransferCTN:
            //   Number(PkValue) == 0
            //     ? 0
            //     : Number(i.SuggestedTransfer) / Number(PkValue) > 0 &&
            //       Number(i.SuggestedTransfer) / Number(PkValue) < 0.99
            //     ? 1
            //     : Math.round(Number(i.SuggestedTransfer) / Number(PkValue)),
            //changes done on 11/102024 (along with shinji ,safia ,sir )
            SuggestedTransferCTN:
              Number(PkValue) === 0 || transferRatio == 0
                ? 0
                : transferRatio > 0 && transferRatio < 0.99
                ? 1
                : Math.round(transferRatio),
            IL_StockCTN: Number(PkValue) == 0 ? 0 : Number(i.IL_Stock) / Number(PkValue),
            IL_FinalQtyCTN:
              Number(PkValue) == 0
                ? 0
                : Number(i.IL_FinalQty) / Number(PkValue) > 0 &&
                  Number(i.IL_FinalQty) / Number(PkValue) < 0.99
                ? 1
                : Math.round(Number(i.IL_FinalQty) / Number(PkValue)),
            DCPickShowing: Number(PkValue) == 0 ? 0 : Number(i.DCPick) / Number(PkValue),
            B_Tsr_Qty: xQty === 0 ? i.B_Tsr_Qty : xQty,
            // B_Tsr_BaseQty: xBaseQty === 0 ? i.B_Tsr_BaseQty : xBaseQty,
            //B_Tsr_UnitRate: xUnitRate === 0 ? i.B_Tsr_UnitRate : xUnitRate,
            isQtyEditAllowed: xisQtyEditAllowed === true ? i.isQtyEditAllowed : xisQtyEditAllowed,
            packingDate: sPackingData?.length > 0 ? sPackingData : i.packingDate
          }
        : i;
    });
    //SuggestedTransferCTN,IL_StockCTN newly added field
    xSetItemList(itemList);
  };
  const setPackQty_Modal = (params) => {
    // let unitObj = params.row.units.find(u => u.Unit === params.row.B_Tsr_Unit);
    // let unitRate = Number((Number(unitObj?.CostPr) * Number(params.value)).toFixed(3));

    let itemList = sPkListRow.map((i) => {
      return i.IL_ItmCd === params.row.IL_ItmCd
        ? {
            ...i,
            PackQty: params.value
          }
        : i;
    });
    //SuggestedTransferCTN,IL_StockCTN newly added field
    setPkListRow(itemList);
    return {
      ...params.row,
      PackQty: params.value
    };
  };

  // const setTSRUnit = (params, unit) => {
  //   let unitObj = params.row.units.find((u) => u.Unit === unit);
  //   let packQty = Number(unitObj?.PackQty);
  //   // let unitRate = Number((Number(unitObj?.CostPr) * packQty).toFixed(3));

  //   let itemList = xItemList.map((i) => {
  //     const transferRatio = Number(i.SuggestedTransfer) / Number(packQty);

  //     return i.IL_ItmCd === params.row.IL_ItmCd
  //       ? {
  //           ...i,
  //           B_Tsr_Unit: unit,
  //           B_Tsr_PackQty: packQty,
  //           // B_Tsr_UnitRate: unitRate,
  //           B_Tsr_UnitRate: Number((Number(i?.CostPr) * packQty).toFixed(3)),
  //           B_Tsr_BaseQty: packQty * Number(i.B_Tsr_Qty),
  //           // SuggestedTransferCTN: Number(packQty) == 0 ? 0 : Number(i.SuggestedTransfer) / packQty,
  //           //changes done on 11/102024 (along with shinji ,safia ,sir )
  //           SuggestedTransferCTN:
  //             Number(packQty) === 0 || transferRatio == 0
  //               ? 0
  //               : transferRatio > 0 && transferRatio < 0.99
  //               ? 1
  //               : Math.round(transferRatio),

  //           IL_StockCTN: Number(packQty) == 0 ? 0 : Number(i.IL_Stock) / packQty,
  //           IL_FinalQtyCTN: Number(packQty) == 0 ? 0 : Number(i.IL_FinalQty) / packQty,
  //           DCPickShowing: Number(packQty) == 0 ? 0 : Number(i.DCPick) / Number(packQty)
  //         }
  //       : i;
  //   });
  //   //SuggestedTransferCTN,IL_StockCTN,IL_FinalQtyCTN newly added field
  //   xSetItemList(itemList);
  //   return { ...params.row, FinalQty: params.value };
  // };

  const fSearchItem = async () => {
    let searchObj = {
      v_VocTyp: rdxHeadObj?.vocTyp,
      v_VocNo: rdxHeadObj?.vocNo,
      v_ItmCd: sItemSearchModalObj.vItemNameCode,
      v_ItmName: sItemSearchModalObj.vItemNameName,
      v_Barcode: sItemSearchModalObj.vItemNameBarcode,
      v_RefNo1: sItemSearchModalObj.vItemNameRefNo
    };

    const res = await getStkTransItemSearch(searchObj);
    return res.ResultSet;
  };

  const GetItemSearchValue = async (e, xOnchangeAPI, xValue) => {
    if (e.key == 'ArrowDown' || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength = document.getElementsByClassName('Mui-selected').length;
        if (selectedLength === 0) {
          let tabel = document.getElementById('table-main-grid-3');
          // vIsDownKeyPressed = true;
          // tabel?.getElementsByClassName('MuiDataGrid-row')[0]?.firstChild?.click();
          // tabel?.getElementsByClassName('MuiDataGrid-row')[0]?.firstChild?.dblclick();
          tabel?.getElementsByClassName('MuiDataGrid-row')[0]?.firstChild?.focus();
        }
      }, 500);
    } else if (e.key == 'Enter' || e._reactName === 'onClick') {
      const result = await fSearchItem();
      if (result.length > 0) {
        let GridSearchItem = result?.map((obj, i) => ({ ...obj, id: i + 1 }));
        setGridSelectRowData(GridSearchItem);
      }
    }
  };
  const fClearItemSearch = useCallback(
    (event) => {
      setItemSearchModalObj({
        vAnydata: '',
        vItemNameCode: '',
        vItemNameName: '',
        vItemNameBarcode: '',
        vItemNameRefNo: ''
      });
      setGridSelectRowData([]);
      setLoadingItemSearch(false);
    },
    [sItemSearchModalObj]
  );

  const fCloseItemSearchModal = () => {
    setItemSearchModal(false);
    fClearItemSearch();
  };
  const fCloseItempackQty = () => {
    setItemPackQtyModal(false);
    setCurrentRowSelected([]);
    setPkListRow([]);
  };

  const fonChangeInputModal = (event) => {
    setItemSearchModalObj({ ...sItemSearchModalObj, [event.target.name]: event.target.value });
  };
  // const fonChangeInputModalSelect = (event) => {
  //     setItemSearchModalObj({ ...sItemSearchModalObj, [event.target.name]: event.target.value });
  //     // GetItemSearchValue("", "GROUP", event.target.value);
  // };
  const fOnRowClickGCItemSearch = async (item) => {
    // dispatchItem(item.row.ItmCd, item.row.Name1);
    const payload = {
      v_VocTyp: rdxHeadObj?.vocTyp,
      v_VocNo: rdxHeadObj?.vocNo,
      v_ItmCd: item.row.ItmCd,
      Units: ''
    };
    const result = await getStkTransItem(payload);
    fAddItem(result?.ResultSet, selectedID);
    setItemSearchModal(false);
  };

  useEffect(() => {
    if (sItemSearchModal) {
      fShowItemSearchModal();
    }
  }, [sItemSearchModal]);

  const fShowItemSearchModal = async () => {
    const payload = {
      trnTyp: 'STCKTSFRITMSRCH'
    };
    const result = await getGitterColumns(payload);
    setGridSelectColData(result?.ResultSet?.columns);
    // setItemSearchModal(true);
  };

  const fOnCellClick = async (params) => {
    console.log('rows', params);

    // console.log('params', params);
    if (params.field === 'ItemName' && params?.row?.IL_ItmCd == '') {
      setSelectedID(params.row.id);
      setItemSearchModal(true);
      // fShowItemSearchModal();
    }
    //10/06/2025 - Just show the data from Api,
    // if (params.field === 'B_Tsr_PackQty' && params.row.isGMSPurActive === false) {
    //   setCurrentRowSelected(params);
    //   let iPkQty = await tsrPackQtyApi({
    //     v_Loc: rdxHeadObj.dcLoc,
    //     v_itmCd: params.row.IL_ItmCd
    //   });
    //   if (iPkQty.ResultSet?.Item?.length > 0) {
    //     let GridSearchItem = iPkQty.ResultSet?.Item?.map((obj, i) => ({ ...obj, id: i + 1 }));
    //     setPkListRow(GridSearchItem);
    //   } else {
    //     setPkListRow([
    //       {
    //         id: 1,
    //         Party: '',
    //         PartyName: '',
    //         Date: new Date(),
    //         PackQty: 1
    //       }
    //     ]);
    //   }
    //   setItemPackQtyModal(true);
    // }
  };

  const onClickDelete = async (params) => {
    confirmAlert({
      title: 'Delete',
      message: 'Are you sure to Delete?',
      buttons: [
        {
          className: 'alertBtn',
          label: 'Yes',
          onClick: async () => {
            xSetItemList(xItemList.filter((x) => x.id != params.row.id));
            const payload = {
              vocType: rdxHeadObj?.vocTyp,
              vocNo: rdxHeadObj?.vocNo,
              loc: rdxHeadObj.loc,
              itmCd: params.row.IL_ItmCd
            };
            const result = await deleteDCStockTransferItem(payload);
            console.log(result, 'result');
          }
        },
        {
          className: 'alertBtn',
          label: 'No',
          onClick: () => {}
        }
      ]
    });
  };

  const isCellEditable = React.useCallback((params) => {
    const editableFields =
      params.field === 'B_Tsr_Unit' ||
      params.field === 'B_Tsr_Qty' ||
      params.field === 'B_Tsr_PackQty' ||
      params.field === 'IL_OverHead' ||
      params.field === 'UnitRate';
    return editableFields;
  }, []);

  const columns = [
    {
      field: 'IL_ItmCd',
      headerName: 'Item Code',
      // flex: 2,
      hide: xMobileScreen,
      width: xMediaQuery ? 100 : 150
    },
    {
      field: 'ItemName',
      headerName: 'Item Name',
      // flex: 5
      width: xMediaQuery ? 120 : 200
    },

    {
      field: 'B_Tsr_PackQty',
      headerName: 'Pack Qty',
      // flex: 2,
      width: xMediaQuery ? 50 : 100,
      align: 'center',
      headerAlign: 'center',
      hide: false,
      editable: true,
      type: 'number',
      valueSetter: (params) => setTSRPackQty(params, params.value),
      cellClassName: 'mui-request-grid-final-qty'
    },
    {
      field: 'B_Tsr_Unit',
      headerName: 'Unit',
      // flex: 3,
      align: 'center',
      headerAlign: 'center',
      hide: true,
      editable: true,
      cellClassName: 'mui-transfer-grid-unit',
      width: xMediaQuery ? 70 : 120
      //type: 'singleSelect',
      //valueOptions: typeData,
    },

    {
      field: 'IL_Stock',
      headerName: 'Stock',
      // flex: 1,
      align: 'center',
      headerAlign: 'center',
      hide: true,
      valueFormatter: ({ value }) => Number(value).toFixed(0),
      width: xMediaQuery ? 50 : 80
    },
    {
      field: 'IL_StockCTN',
      headerName: 'Stock',
      // flex: 1,
      align: 'center',
      headerAlign: 'center',
      hide: xMobileScreen,
      valueFormatter: ({ value }) => Number(value).toFixed(0),
      width: xMediaQuery ? 50 : 80
    },
    {
      field: 'DCPick',
      headerName: 'DCPickNormal',
      // flex: 2,
      hide: true,
      align: 'center',
      headerAlign: 'center',
      valueFormatter: ({ value }) => Number(value).toFixed(0),
      width: xMediaQuery ? 50 : 80
    },
    {
      field: 'DCPickShowing',
      headerName: 'DCPick',
      // flex: 2,
      hide: false,
      align: 'center',
      headerAlign: 'center',
      // valueFormatter: ({ value }) => Number(value).toFixed(0),
      valueFormatter: ({ value }) => Number(value).toFixed(2),
      width: xMediaQuery ? 50 : 100,
      renderCell: (params) => {
        const v = Number(params.value);
        return <span>{!v ? '' : v.toFixed(2)}</span>;
      }
    },
    {
      field: 'PurchaseRatio',
      headerName: 'Ratio of Purchase',
      flex: 2,
      align: 'center',
      headerAlign: 'center',
      hide: true,
      valueFormatter: ({ value }) => (value > 0 ? Number(value).toFixed(2) : 0)
    },
    {
      field: 'B_Tsr_Qty',
      headerName: 'Qty',
      // flex: 2,
      align: 'center',
      headerAlign: 'center',
      hide: false,
      valueSetter: (params) => setTSRQty(params, params.value, params.value.B_Tsr_PackQty),
      editable: true,
      type: 'number',
      cellClassName: 'mui-request-grid-final-qty',
      width: xMediaQuery ? 50 : 80
    },

    {
      field: 'B_Tsr_BaseQty',
      headerName: 'Base Qty',
      // flex: 1,
      align: 'center',
      headerAlign: 'center',
      hide: xMediaQuery,
      width: xMediaQuery ? 50 : 80
    },
    {
      field: 'B_Tsr_UnitRate',
      headerName: 'Unit rate',
      // flex: 2,
      align: 'right',
      headerAlign: 'right',
      width: xMediaQuery ? 50 : 80,
      valueFormatter: ({ value }) => (value > 0 ? Number(value).toFixed(2) : 0)
    },
    {
      field: 'IL_OverHead',
      headerName: 'OverHead',
      // flex: 2,
      align: 'right',
      headerAlign: 'right',
      width: xMediaQuery ? 50 : 80,
      editable: true,
      type: 'number',
      valueSetter: (params) => setTSROverHead(params, params.value),
      cellClassName: 'mui-request-grid-final-qty',
      valueFormatter: ({ value }) => (value > 0 ? Number(value).toFixed(2) : 0)
    },
    {
      field: 'delete',
      headerName: '',
      // flex: 1,
      align: 'center',
      headerAlign: 'center',
      hide: false,
      width: xMediaQuery ? 50 : 90,

      renderCell: (params) => {
        return (
          <IconButton
            size="small"
            color="primary"
            onClick={() => {
              onClickDelete(params);
            }}
            disabled={
              rdxHeadObj.status.toString().toUpperCase() !== 'ENTER' || params.row.IL_Type == 'Auto'
            }>
            <DeleteOutline />
          </IconButton>
        );
      }
    }
  ];

  return (
    <>
      <Box
        sx={{
          height: xMediaQuery ? (xMobileScreen ? '59vh' : '61vh') : '62vh',
          width: '100%',
          '& .actions': {
            color: 'text.secondary'
          },
          '& .textPrimary': {
            color: 'text.primary'
          }
        }}>
        <DataGrid
          getRowId={(row) => row.id}
          rowHeight={35}
          headerHeight={35}
          disableColumnSelector
          sx={{
            border: 2,
            borderColor: 'primary.light',
            // color: '#000000',
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: '#0d73bb',
              color: 'white'
            },
            '&.MuiDataGrid-row.Mui-selected': {
              backgroundColor: 'none !important'
            }
          }}
          componentsProps={{
            filterPanel: { sx: { maxWidth: '93vw' } }
          }}
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0 ? 'mui-even-row' : 'mui-odd-row'
          }
          rows={xItemList}
          columns={columns}
          onCellClick={(params) => {
            fOnCellClick(params);
          }}
          isCellEditable={isCellEditable}
        />
      </Box>
      <Modal
        open={sItemSearchModal}
        onClose={fCloseItemSearchModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box className="model-sales-invoice-GCVanMaster-Modal">
          <GCItemSearch
            fCloseItemSearch={fCloseItemSearchModal}
            title={'Item'}
            xOnRowClick={(item) => fOnRowClickGCItemSearch(item)}
            xItemRows={sGridSelectRowData}
            xItemColumn={sGridSelectColData}
            xonChangeInputModal={fonChangeInputModal}
            fonChangeInputModalSelect={() => {}}
            xItemSearchModalObj={sItemSearchModalObj}
            xfClear={fClearItemSearch}
            xGetItemSearchValue={GetItemSearchValue}
            sLoadingItemSearch={sLoadingItemSearch}
            vMediaQuery={xMediaQuery}
            xEnterObj={sEnterKeyObj}
            vRdxDBLocationGroup={[]}
            xanyData={false}
            xgroup={false}
            xnameFL={false}
          />
        </Box>
      </Modal>
      <Modal
        open={sItemPackQtyModal}
        onClose={fCloseItempackQty}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box className="model-sales-invoice-GCVanMaster-Modal">
          <Box sx={{ flexGrow: 1 }} className="gnr-item-search  GCItemSearch-Modal">
            <Grid container spacing={0} className="grnt-item-search-title">
              <Grid item xs={12} className="item-search d-flex justify-content-between">
                <span> Packing List</span>
                <CloseIcon className="grnt-item-search-close-icon" onClick={fCloseItempackQty} />
              </Grid>
            </Grid>
            <Grid container spacing={2} className="search-item mt-2">
              <Grid item xs={12} className=" height-table-scroll " component="div">
                <div
                  style={{ height: xMediaQuery ? '45vh' : '50vh', width: '100%' }}
                  id="table-main-grid-3"
                  className="search-grid-table ">
                  <Box
                    style={{ height: '100%', width: '100%' }}
                    className="bintransfer-out-grid px-2">
                    <DataGrid
                      rowHeight={30}
                      headerHeight={40}
                      getRowClassName={(params) =>
                        params.indexRelativeToCurrentPage % 2 === 0 ? 'mui-even-row' : 'mui-odd-row'
                      }
                      sx={{
                        border: 1,
                        borderColor: 'primary.light'
                      }}
                      componentsProps={{
                        filterPanel: { sx: { maxWidth: '93vw' } }
                      }}
                      rows={sPkListRow}
                      columns={[
                        {
                          field: 'PackQty',
                          headerName: 'PackQty',
                          hide: false,
                          width: 90,
                          align: 'center',
                          headerAlign: 'center',
                          Typ: 'S',
                          // NumberFormat: '0',
                          valueSetter: setPackQty_Modal,
                          editable: true,
                          type: 'number',
                          cellClassName: 'mui-request-grid-final-qty'
                        },

                        {
                          field: 'Party',
                          headerName: 'PartyCd',
                          hide: true,
                          width: 100,
                          align: 'left',
                          headerAlign: 'left',
                          Typ: 'S',
                          NumberFormat: '0'
                        },
                        {
                          field: 'PartyName',
                          headerName: 'Party',
                          hide: false,
                          width: 400,
                          align: 'left',
                          headerAlign: 'left',
                          Typ: 'S',
                          NumberFormat: '0'
                        },
                        {
                          field: 'Date',
                          headerName: 'Date',
                          hide: false,
                          width: 100,
                          align: 'left',
                          headerAlign: 'left',
                          Typ: 'S',
                          NumberFormat: '0',
                          valueFormatter: ({ value }) => moment(value).format('DD/MM/YYYY')
                        },
                        {
                          field: 'delete',
                          headerName: '',
                          // flex: 1,
                          align: 'center',
                          headerAlign: 'center',
                          hide: false,
                          width: xMediaQuery ? 50 : 150,
                          editable: true,
                          renderCell: (params) => {
                            return (
                              <IconButton
                                size="small"
                                color="primary"
                                onClick={() => {
                                  setPackQty_V1(sCurrentRowSelected, params.row.PackQty, 0);
                                  fCloseItempackQty();
                                }}
                                disabled={isEditing}>
                                <SaveIcon />
                              </IconButton>
                            );
                          }
                        }
                      ]}
                      getRowId={(row) => row.id}
                      hideFooter
                      // onColumnHeaderEnter={}
                      // onCellKeyDown={xOnCellKeyDown}
                      onRowClick={(params) => {
                        // console.log('safdasd', sCurrentRowSelected, params.row.PackQty);
                        // setPackQty_V1(sCurrentRowSelected, params.row.PackQty);
                        // fCloseItempackQty();
                      }}
                      onCellEditStart={handleEditCellChange}
                      onCellEditStop={handleEditCellChangeCommitted}
                    />
                  </Box>
                </div>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Modal>

      <RequestPackQtySelection
        data={sSelectedRow}
        subDataGrid={sPackingData}
        setSubDataGrid={setPackingData}
        open={sPackingModal}
        onClose={() => setPackingModal(false)}
        calculate_PackQty={setPackQty_V1}
        calculate_Qty={setTSRQty}
        title={'Pack Qty - Selection'}
        sCurrentRowSelected={sCurrentRowSelected}
      />
    </>
  );
}
